import { Component, OnInit, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { LoopBackConfig, LoopBackAuth } from '../../../../../assets/js/lb-sdk';
import { UploadInput, UploadOutput, UploaderOptions } from 'ngx-uploader';
import { STORAGE_LOCATIONS, UPLOAD_TYPE } from '../../../../enums';
import { formatEvent } from '@app/helpers/upload-input-formatter'

interface BankTransactionForm {
  type: number;
  file?: any
};

@Component({
  selector: 'app-bank-transactions-form',
  templateUrl: './bank-transactions-form.component.html',
  styleUrls: ['./bank-transactions-form.component.css']
})
export class BankTransactionsFormComponent implements OnInit {
  data: BankTransactionForm;
  loading: boolean = false;
  error: string;
  file;
  uploadInput: EventEmitter<UploadInput> = new EventEmitter<UploadInput>();
  options: UploaderOptions = {
    concurrency: 1,
    allowedContentTypes: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
  };

  constructor(
    public modal: BsModalRef,
    private loopBackAuth: LoopBackAuth
  ) { }

  ngOnInit() {
    this.data = this.data || {
      type: UPLOAD_TYPE.BANK_TRANSACTION
    };
  }

  onUploadOutput(output: UploadOutput) {
    switch (output.type) {
      case 'addedToQueue':
        if (typeof output.file !== 'undefined') {
          this.error = undefined;
          this.file = output.file;
        }
        break;
      case 'start':
        this.loading = true;
        break;
      case 'rejected':
        this.data.file = undefined;
        this.file = undefined;
        this.error = "File Rejected";
        break;
      case 'done':
        setTimeout(() => {
          this.loading = false;
          if (output.file && output.file.responseStatus === 200) {
            this.modal.content.result = 'success';
            this.modal.hide();
          } else {
            this.data.file = undefined;
            this.file = undefined;
            this.error = "File Upload failed";
          }
        }, 1000);
        break
      default:
        break;
    }
  }

  dismiss(reason: string) {
    this.modal.content.reason = reason;
    this.modal.hide();
  }

  getUser() {
    return this.loopBackAuth.getToken() ? this.loopBackAuth.getCurrentUserData() : undefined;
  }

  close(form) {
    if (form.valid) {
      if (this.data.file) {
        const path = LoopBackConfig.getPath() + '/api/AmazonS3/' + STORAGE_LOCATIONS.BANK_TRANSACTIONS + '/upload';
        if (path && path !== '') {
          var Authorization = this.loopBackAuth.getToken() && this.loopBackAuth.getToken().id || ''
          const data = {
            type: this.data.type.toString(),
            uploader: this.getUser().id,
          }
          const event = formatEvent('uploadAll',path,Authorization, data)
          this.uploadInput.emit(event);
        }
      }
    }
  }
}
